import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-new-info',
  templateUrl: './new-info.component.svg',
  styleUrls: ['./new-info.component.scss']
})
export class NewInfoComponent implements OnChanges {
  @Input() amount: number = -1;
  @Input() max: number = 99;
  @Input() size: number = 22;

  public display: string = '!';

  constructor() {}

  ngOnChanges(): void {
    this.display = this.amount > this.max ? `${this.max.toFixed()}+` : this.amount > 0 ? this.amount.toFixed() : '!';
  }
}
